import { React } from 'react';
import '../styles/components/hero.scss'

const Hero = ({first, second, contents, gradOne, gradTwo, logo, hide, color, size}) => (
    <div className="hero-container" style={{height: size}}>
        <div className="hero-item">
            {  contents }
        </div>
        <div className="first" id={`${hide && 'hide'}`}style={{backgroundImage: `linear-gradient(${gradOne}, url(${process.env.PUBLIC_URL + first})`, backgroundColor: color, height: size}}>
            <img src={`${logo}`} alt="" />
        </div>
        <div className="second" id={`${hide && 'length'}`} style={{backgroundImage:`linear-gradient(${gradTwo},url(${process.env.PUBLIC_URL + second})`, height: size}}></div>
    </div>
)

export default Hero;